import moment from 'moment'
import { Lang } from '../translations/lang'

export function toFormattedDate(dateTime: string | undefined | null): string {
  return dateTime ? moment(dateTime).format(Lang.dateFormat) : ''
}
